// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA0fD4Ln_VdHf5c4d65DdQOpmKupvsVcKc",
  authDomain: "clipdleauth.firebaseapp.com",
  projectId: "clipdleauth",
  storageBucket: "clipdleauth.appspot.com",
  messagingSenderId: "510657310211",
  appId: "1:510657310211:web:350b6270040c7b4d042836",
  measurementId: "G-BGTH3WNH8N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

export default {
  auth,
  // other services like analytics, firestore, etc.
};